"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ramda = require("ramda");

var _default = function _default(rootSelector) {
  return {
    data: (0, _ramda.compose)((0, _ramda.prop)("data"), rootSelector),
    error: (0, _ramda.compose)((0, _ramda.prop)("error"), rootSelector),
    isFetching: (0, _ramda.compose)((0, _ramda.prop)("isFetching"), rootSelector),
    lastUpdated: (0, _ramda.compose)((0, _ramda.prop)("lastUpdated"), rootSelector)
  };
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-server-middleware/lib/helpers/createSelectors.js
// module id = 1217
// module chunks = 0